export default __webpack_public_path__ + "static/media/partner-maticlaunch.1eb98dea.png";